module.exports = __webpack_public_path__ + "static/media/none-selected.183f53bd.svg";